import { http } from "../http/Http";
import { Query } from "../models/Query";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";

export class QueryService {

    getQueriesByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<Query[]>> => {
        const { data } = await http.post<ServiceResponse<Query[]>>("Query/GetByFilters", apiQueryFilter);
        return data;
    };

    getQuery = async (id: number): Promise<Query> => {
        const { data } = await http.get<Query>(("Query/GetById/" + id.toString()));
        return data;
    };

    addQuery = async (query: Query): Promise<Query> => {
        const { data } = await http.post<Query>("Query/Post", query);
        return data;
    };

    updateQuery = async (query: Query): Promise<Query> => {
        const { data } = await http.put<Query>("Query/Put", query);
        return data;
    };

    updateQueriesIndex = async (queries: any): Promise<ServiceResponse<Query[]>> => {
        const { data } = await http.put<ServiceResponse<Query[]>>("Query/UpdateQueriesIndex", queries);
        return data;
    };

}